module.exports = __webpack_public_path__ + "img/pr-10.ca9593cb.png";